const FETCH_WORKED_HOURS_REPORTS = 'fetch_workedHoursReports';
const FETCH_WORKED_HOURS_REPORTS_CSV = 'fetch_workedHoursReports_csv';

export default {
    FETCH_WORKED_HOURS_REPORTS,
    FETCH_WORKED_HOURS_REPORTS_CSV,
};
